// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import platformSingleton from '../../platform/platformSingleton';
import { hasCommandModifier } from '../../utils/keyboard/keyboardUtility';
import { isPlatformNativeApp } from '../../platform/utils/platformDetailsUtils';

// Actions
import { modalClosed } from './modalActions';

// Components
import ModalManager from './ModalManager';

// Constants
import { KEY_CODES } from '../../utils/keyboard/keyConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchModalClose: (modalName) => dispatch(modalClosed(modalName)),
});

const NonRouteModalManager = (props) => {
    const { children, dispatchModalClose } = props;

    React.useEffect(() => {
        const onKeyDown = (event) => {
            // Back browser navigation keys
            if (event.keyCode === KEY_CODES.OPEN_BRACKET && hasCommandModifier(event)) {
                event.preventDefault();
                event.stopPropagation();
                dispatchModalClose();
            }
        };

        const onPopState = () => {
            // This event is used to handle the back button on the browser, however there's no visible back
            // button on the electron app and it causes problems in the share modal, because for some reason
            // the popstate event is fired every time there's a URL change in the electron, despite it not
            // actually adding to the page history.
            // This does mean that "History > Back" menu item no longer works when the Shortcut or Share
            // modals are open, but I doubt anyone ever uses that anyway
            if (isPlatformNativeApp(platformSingleton)) return;

            dispatchModalClose();
        };

        window.addEventListener('keydown', onKeyDown);
        // TODO See if we can somehow prevent the navigation. preventDefault & stopPropagation don't seem to work
        window.addEventListener('popstate', onPopState);

        return () => {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('popstate', onPopState);
        };
    }, []);

    return <ModalManager dispatchModalClose={dispatchModalClose}>{children}</ModalManager>;
};

NonRouteModalManager.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    dispatchModalClose: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(NonRouteModalManager);
